// extracted by mini-css-extract-plugin
export default {"wrap":"PounceToggle_wrap__+fP4A","dot":"PounceToggle_dot__nj3yB","track":"PounceToggle_track__1uP5f","knob":"PounceToggle_knob__xuxUs","on":"PounceToggle_on__ru5yf"};